module.exports = __webpack_public_path__ + "img/logo.06ed7eb6.png";